// src/services/audioService.js

export default {
    playAlarm() {
      const audio = new Audio('/audio/Industrial Alarm-SoundBible.com-1012301296.wav');
      audio.play();
    },
    success() {
      const audio = new Audio('/audio/success.mp3');
      audio.play();
    },
    ban() {
      const audio = new Audio('/audio/ban.wav');
      audio.play();
    },
    ops() {
      const audio = new Audio('/audio/ops.mp3');
      audio.play();
    }
  };
  